import { getPersonalization } from '@nile/graphql';
import { getCurrentUserHook } from '@nile/components';
import { isEmpty } from 'lodash';
import { savePersonalization } from '@nile/graphql';
import { useState } from 'react';

let personalisation = {};
const OnBoardingPersonalisationHook = () => {
  const data = {
    ai: {
      url:
        'https://embed.figma.com/proto/jWI78Fkh3bGf6RjEudAcrW/Monica-AI---Awareness?page-id=0%3A1&node-id=0-119&node-type=canvas&viewport=697%2C402%2C0.15&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=0%3A119&share=1&embed-host=share',
      personalisationId: 'aiOnboarding'
    }
  };
  const [personalisationData, setPersonalisationData] = useState(null);
  const currentUser = getCurrentUserHook();
  const [loading, setLoading] = useState(true);
  const getOnBoardingPersonalisation = async (user, callBack) => {
    if (!isEmpty(user?.userId)) {
      setLoading(true);
      const response = await getPersonalization({
        userId: user?.userId,
        name: 'chat-onboarding-personalisation',
        category: user?.userId
      });
      setLoading(false);
      const data = response?.data?.getPersonalizationByCategoryAndName;

      if (callBack) {
        callBack({
          data: !isEmpty(data) ? JSON.parse(data?.value) : null
        });
      }

      if (!isEmpty(data)) {
        personalisation = JSON.parse(data?.value);
        setPersonalisationData(JSON.parse(data?.value));
      } else {
        return null;
      }
    }
  };

  const showPersonalisation = (featureName) => {
    const featureData = data?.[featureName];
    let show = false;

    if (featureData?.personalisationId) {
      const personalisationId = featureData?.personalisationId;
      if (personalisationId) {
        show = personalisationData?.[personalisationId] || false;
      }
    }

    return show;
  };

  const saveOnboardingPersonalisation = (obj) => {
    if (!isEmpty(obj)) {
      const updatedData = !isEmpty(personalisationData)
        ? { ...personalisationData, ...obj }
        : { ...obj };
      const variables = {
        user: {
          firstName: currentUser?.firstName,
          userId: currentUser?.userId,
          email: currentUser?.email,
          lastName: currentUser?.lastName
        },
        name: 'chat-onboarding-personalisation',
        category: currentUser?.userId,
        value: JSON.stringify(updatedData)
      };
      savePersonalization({
        variables: variables,
        input: variables
      }).then((res) => {
        if (res?.data?.savePersonalization) {
          setPersonalisationData(updatedData);
        }
      });
    }
  };
  return {
    getOnBoardingPersonalisation,
    saveOnboardingPersonalisation,
    personalisationData,
    onboardingPersonalisationLoading: loading,
    showPersonalisation
  };
};
export default OnBoardingPersonalisationHook;
